import React, { useState } from 'react';
import Button from '@elements/Button';
import LogoDown from '@svg/icons/arrow-down.svg';

import './style.css';

import SubModuleSelector from '@submodules/SubModuleSelector';

type ContainerGridAccordionProps = {
  item: {
    contentful_id: string;
    classes: string;
    background: string;
    modules: ModuleProps[];
    moduleName: string;
  };
};

const ContainerGridAccordion = ({ item }: ContainerGridAccordionProps): JSX.Element => {
  const { modules: submodules, moduleName, classes } = item;
  const moduleClasses = moduleName.replace(/ /g, "-").toLowerCase();
  const [collapse, setCollapse] = useState(true);

  switch (true) {
    case item.classes?.includes('products'):
      return (
        <div
          className={
            `acordion-products-item ${
              collapse
              ? 'acordion-products-item--collapsed'
              : ''
            }`
          }
        >
          <div className="acordion-products-item__title">
            { moduleName }
            <Button
              ariaLabel="icon-arrow"
              onClick={ ()=> setCollapse(!collapse) }
            >
              <LogoDown />
            </Button>
          </div>
          <div className="acordion-products-item__body">
              <div className={"container-grid-accordion"}>
                <section className={ moduleClasses }>
                  <SubModuleSelector submodules={submodules} />
                </section>
              </div>
          </div>
        </div>
      );
    case item.classes?.includes('packages'):
      return (
        <div
          className={
            `acordion-packages-item ${
              !collapse
              ? 'acordion-packages-item--collapsed'
              : ''
            }`
          }
        >
          <div className="acordion-packages-item__title">
            { moduleName }
            <Button
              ariaLabel="icon-arrow"
              onClick={ ()=> setCollapse(!collapse) }
            >
              <LogoDown />
            </Button>
          </div>
          <div className="acordion-packages-item__body">
              <div className={"container-grid-accordion"}>
                <section className={ moduleClasses }>
                  <SubModuleSelector submodules={submodules} />
                </section>
              </div>
          </div>
        </div>
      );
    default:
      return (
        <div
          className={
            `acordion-products-item ${
              collapse
              ? 'acordion-products-item--collapsed'
              : ''
            }`
          }
        >
          <div className="acordion-products-item__title">
            { moduleName }
            <Button
              ariaLabel="icon-arrow"
              onClick={ ()=> setCollapse(!collapse) }
            >
              <LogoDown />
            </Button>
          </div>
          <div className="acordion-products-item__body">
              <div className={"container-grid-accordion"}>
                <section className={ moduleClasses }>
                  <SubModuleSelector submodules={submodules} />
                </section>
              </div>
          </div>
        </div>
      );
  }
};

export default ContainerGridAccordion;
